import noop from 'lodash/noop';

const onResolve = <T>(p: T) => ({ value: p, rejected: false });
const onReject = <T>(p: T) => ({ value: p, rejected: true });

/**
 * Reflects a promises resolution (whether it is a success or failure) to a resolved value
 * containing a rejected flag as well as the value of the resolve/rejected promise.
 */
export const reflect = <T>(promise: Promise<T>) => {
  return promise.then(onResolve).catch(onReject);
};

export const ignoreResponse = <T>(promise: Promise<T>) => {
  return promise.catch(noop);
};
